export default __webpack_public_path__ + "static/media/rider_reject.a8612a7e.wav";